function isValidHttpUrl(string) {
    var res = string.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g);
    return (res !== null)
}

document.addEventListener("DOMContentLoaded", (e) => {
    let toggles = document.querySelectorAll(".js-checkbox-status");

    toggles.forEach(toggle => {
        toggle.addEventListener('click', function() {
            const checkbox = this.querySelector('input[type="checkbox"]');
            const info = this.closest('.notification-modal').querySelector('.modal-form');
            const span = this.querySelector('span');

            checkbox.checked = !checkbox.checked;

            if(checkbox.checked) {
                this.classList.remove('bg-gray-400');
                this.classList.add('bg-blue-600');
                span.classList.remove('translate-x-0');
                span.classList.add('translate-x-5');
                info.classList.remove('hidden');
            } else {
                this.classList.remove('bg-blue-600');
                this.classList.add('bg-gray-400');
                span.classList.remove('translate-x-5');
                span.classList.add('translate-x-0');
                info.classList.add('hidden');
            }

            this.setAttribute('aria-checked', checkbox.checked);
        });
    });

    let webhookUrl = document.getElementById('webhook_url');

    if(webhookUrl){
        webhookUrl.addEventListener('keyup', function() {
            if(!isValidHttpUrl(this.value)){
                this.classList.remove('bg-green-100');
                this.classList.add('bg-red-200');
            } else {
                this.classList.remove('bg-red-200');
                this.classList.add('bg-green-100');
            }
        })
    }

    // FreshService custom fields functionality
    const handleCustomFields = () => {
        // Add custom field button handler
        document.querySelectorAll('.add-custom-field').forEach(button => {
            button.addEventListener('click', function(e) {
                e.preventDefault();
                const container = this.previousElementSibling;
                const newField = document.createElement('div');
                newField.className = 'flex gap-2 custom-field-row items-center';
                newField.innerHTML = `
                    <input type="text" name="freshservice_custom_fields_key[]" class="border p-2 rounded flex-1 border-gray-200 dark:border-gray-700 dark:bg-neutral-700" placeholder="Field Name">
                    <input type="text" name="freshservice_custom_fields_value[]" class="border p-2 rounded flex-1 border-gray-200 dark:border-gray-700 dark:bg-neutral-700" placeholder="Field Value">
                    <button type="button" class="remove-custom-field bg-red-500 text-white p-2 rounded hover:bg-red-600" title="Remove field">
                      <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-5 h-5">
                        <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
                      </svg>
                    </button>
                `;
                container.appendChild(newField);
                attachRemoveHandlers();
            });
        });

        // Function to attach remove handlers
        const attachRemoveHandlers = () => {
            document.querySelectorAll('.remove-custom-field').forEach(button => {
                button.removeEventListener('click', removeFieldHandler);
                button.addEventListener('click', removeFieldHandler);
            });
        };

        // Remove field handler
        const removeFieldHandler = function(e) {
            e.preventDefault();
            this.closest('.custom-field-row').remove();
        };

        // Initial attachment of remove handlers
        attachRemoveHandlers();
    };

    // Initialize custom fields handlers
    handleCustomFields();

    // Re-initialize when modals are opened (for dynamically loaded content)
    document.addEventListener('modal:opened', handleCustomFields);
});